// Generated by purs version 0.11.6
"use strict";
var Control_Applicative = require("../Control.Applicative");
var Control_Bind = require("../Control.Bind");
var Control_Monad_Eff = require("../Control.Monad.Eff");
var Data_Function = require("../Data.Function");
var Data_Unit = require("../Data.Unit");
var Prelude = require("../Prelude");
var React = require("../React");
var React_DOM_Props = require("../React.DOM.Props");
var React_DOM_SVG_Dynamic = require("../React.DOM.SVG.Dynamic");
var box = React.createClass(React.spec(Data_Unit.unit)(function (ctx) {
    return function __do() {
        var v = React.getProps(ctx)();
        var ui = React_DOM_SVG_Dynamic.rect([ React_DOM_Props.style({
            fill: "rgba(0, 162, 255, 0.2)"
        }), React_DOM_Props.height(v.height), React_DOM_Props.width(v.width), React_DOM_Props.x(v.x), React_DOM_Props.y(v.y) ])([  ]);
        return ui;
    };
}));
module.exports = {
    box: box
};
